import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import { getViewPathForAnalysis } from '../../analyses/common/analysisUrlHelper';
import { DisplayableContent } from './ConnectedKfaPropTypes';

export const AnalysisTitleLink = ({ analysis, projectId, testId }) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  return (
    <Link
      to={getViewPathForAnalysis(projectId, analysis, false, isPwcUser)}
      key={analysis.contentId}
      data-testid={testId}
      className="connected-analyses__list__link"
    >
      {analysis.title}
    </Link>
  );
};

AnalysisTitleLink.propTypes = {
  analysis: PropTypes.shape(DisplayableContent).isRequired,
  projectId: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
};
